import React, { useRef } from "react";
import { useWindowVirtualizer } from "@tanstack/react-virtual";
import { SearchInput } from "../form/Input/Input";
import { useProcessedItems } from "./hooks/useProcessedItems";
import NoData from "../noData/noData";
import "./WindowVirtualList.scss";

export function WindowVirtualList({
  rawItems = [],
  renderRow,
  estimateSize = () => 50,
  overscan = 2,
  getKey = (_, index) => index,
  processItemsFn
}) {
  const listRef = useRef(null);

  const { processedItems, searchValue, setSearchValue } = useProcessedItems(
    rawItems,
    processItemsFn
  );

  const rowVirtualizer = useWindowVirtualizer({
    count: processedItems.length,
    estimateSize,
    overscan,
    scrollMargin: listRef.current?.offsetTop
  });

  const virtualItems = rowVirtualizer.getVirtualItems();

  return (
    <>
      <div id="virtualListSearch">
        {/* The form tag is necessary to disable autocomplete, since autocomplete=‘off’ does not work */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchValue}
            onClear={() => setSearchValue("")}
            onChange={setSearchValue}
          />
        </form>
      </div>
      {!processedItems.length ? (
        <NoData size="medium" />
      ) : (
        <div ref={listRef}>
          <div
            style={{
              width: "100%",
              height: rowVirtualizer.getTotalSize(),
              position: "relative"
            }}
          >
            {virtualItems.map(({ index, start }) => {
              const item = processedItems[index];
              return (
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    transform: `translateY(${start - rowVirtualizer.options.scrollMargin || 0}px)`
                  }}
                  key={getKey(item, index)}
                  data-index={index}
                  ref={rowVirtualizer.measureElement}
                >
                  {renderRow({
                    item,
                    index,
                    measure: () => {
                      const el = listRef.current?.querySelector(`[data-index="${index}"]`);
                      if (el) rowVirtualizer.measureElement(el);
                    }
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
